// extracted by mini-css-extract-plugin
export var errorIcon = "_q6-1";
export var nameLogo = "_q6-0";